// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sugYQ","inner":"styles_inner__1VuCx","right":"styles_right__Dq-M5","close":"styles_close__3hotf","footer":"styles_footer__a5HKv"};